import axios from 'axios'

if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = 'https://localhost:5001/';
}
